import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';

import { getString } from '../../../../helpers/stringHelpers.js';
import EmergencyContactsCard from './EmergencyContactsCard/EmergencyContactsCard';
import IndentedCardHeader from '../../../../components/IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../../../components/IndentedCardContent/IndentedCardContent.js';
import EmergencyContactsDialog from './EmergencyContactsDialog/EmergencyContactsDialog';
import ConfirmedDialog from '../../../../components/ConfirmedDialog/ConfirmedDialog';
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog';
import DeleteDialog from '../../../../components/DeleteDialog/DeleteDialog';
import FabWithText from '../../../../components/FabWithText/FabWithText';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class EmergencyContactsSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      createEditDialogOpen: false,
      confirmDialogOpen: false,
      deleteDialogOpen: false,
      initialDialogData: {
        name: '',
        phone: '',
        id: '',
      },
      submitDialogData: {
        name: '',
        phone: '',
        id: '',
      },
    };

    this.setDialogValues = this.setDialogValues.bind(this);
    this.editContact = this.editContact.bind(this);
    this.removeContact = this.removeContact.bind(this);
    this.handleConfirmed = this.handleConfirmed.bind(this);
    this.resetDialogValues = this.resetDialogValues.bind(this);
    this.createContact = this.createContact.bind(this);
    this.toggleCreateEditDialog = this.toggleCreateEditDialog.bind(this);
    this.toggleConfirmDialog = this.toggleConfirmDialog.bind(this);
    this.toggleDeleteDialog = this.toggleDeleteDialog.bind(this);
    this.handleCreateEditDialogSubmit =
      this.handleCreateEditDialogSubmit.bind(this);
    this.handleConfirmDialogSubmit = this.handleConfirmDialogSubmit.bind(this);
    this.handleDeleteDialogSubmit = this.handleDeleteDialogSubmit.bind(this);
  }

  toggleConfirmDialog() {
    this.setState({ confirmDialogOpen: !this.state.confirmDialogOpen });
  }

  toggleDeleteDialog() {
    this.setState({ deleteDialogOpen: !this.state.deleteDialogOpen });
  }

  handleConfirmed() {
    const { setConfirmedOpen } = this.props;
    setConfirmedOpen();
  }

  resetDialogValues() {
    this.setState({
      initialDialogData: {
        name: '',
        phone: '',
        id: '',
      },
    });
  }

  setDialogValues(index) {
    const { emergencyContactData } = this.props;

    this.setState({
      initialDialogData: {
        name: emergencyContactData[index].name,
        phone: emergencyContactData[index].phone,
        id: emergencyContactData[index].id,
      },
    });
  }

  toggleCreateEditDialog() {
    this.setState({
      createEditDialogOpen: !this.state.createEditDialogOpen,
    });
  }

  toggleConfirmDialog() {
    this.setState({
      confirmDialogOpen: !this.state.confirmDialogOpen,
    });
  }

  toggleDeleteDialog() {
    this.setState({
      deleteDialogOpen: !this.state.deleteDialogOpen,
    });
  }

  editContact(index) {
    this.setDialogValues(index);
    this.toggleCreateEditDialog();
  }

  createContact() {
    this.resetDialogValues();
    this.toggleCreateEditDialog();
  }

  removeContact(index) {
    const { emergencyContactData } = this.props;

    this.setState({ contactToDelete: emergencyContactData[index] });

    this.toggleDeleteDialog();
  }

  handleCreateEditDialogSubmit(dialogData) {
    this.setState({
      submitDialogData: dialogData,
    });
    this.toggleCreateEditDialog();
    this.toggleConfirmDialog();
  }

  handleConfirmDialogSubmit() {
    const { updateContact } = this.props;
    const { initialDialogData, submitDialogData } = this.state;

    const contacts = [
      submitDialogData.name != initialDialogData.name ||
      submitDialogData.phone != initialDialogData.phone
        ? {
            contactName: submitDialogData.name,
            value: submitDialogData.phone,
            type: 'emergency',
            id: submitDialogData.id,
            updating: true,
          }
        : null,
    ];

    updateContact('1', contacts);
    this.toggleConfirmDialog();
  }

  handleDeleteDialogSubmit() {
    const { setContactToDelete, deleteContact } = this.props;

    setContactToDelete(this.state.contactToDelete.id);

    deleteContact(this.state.contactToDelete.id);
  }

  render() {
    const { classes, emergencyContactData, confirmedOpen, canEdit } =
      this.props;

    const stringsComponent = 'contactDetails';

    let contact1name = null;
    let contact1phone = null;
    let contact1updating = false;
    if (emergencyContactData.length > 0) {
      contact1name = emergencyContactData[0].name;
      contact1phone = emergencyContactData[0].phone;
      contact1updating = emergencyContactData[0].updating;
    }

    let contact2name = null;
    let contact2phone = null;
    let contact2updating = false;
    if (emergencyContactData.length > 1) {
      contact2name = emergencyContactData[1].name;
      contact2phone = emergencyContactData[1].phone;
      contact2updating = emergencyContactData[1].updating;
    }

    const addFab =
      canEdit && emergencyContactData.length < 2 ? (
        <FabWithText
          label={getString(stringsComponent, 'ADD_EMERGENCY_LABEL')}
          icon={AddIcon}
          action={() => this.createContact()}
        />
      ) : null;

    let dialogTitle = '';
    let dialogIcon = null;
    if (
      this.state.initialDialogData.name ||
      this.state.initialDialogData.phone ||
      this.state.initialDialogData.id
    ) {
      // Edit mode
      dialogTitle = getString(stringsComponent, 'EDIT_EMERGENCY_TITLE');
      dialogIcon = EditIcon;
    } else {
      // Create mode
      dialogTitle = getString(stringsComponent, 'CREATE_EMERGENCY_TITLE');
      dialogIcon = AddIcon;
    }

    return (
      <div className={classes.root}>
        <Card>
          <IndentedCardContent
            body={
              <div className={classes.bodyContainer}>
                <EmergencyContactsCard
                  contact1name={contact1name}
                  contact1phone={contact1phone}
                  contact1updating={contact1updating}
                  contact2name={contact2name}
                  contact2phone={contact2phone}
                  contact2updating={contact2updating}
                  editAction={(index) => this.editContact(index)}
                  removeAction={
                    // Emergency contacts can only be removed if there is more
                    // than one emergency contact.
                    emergencyContactData.length > 1
                      ? (index) => this.removeContact(index)
                      : null
                  }
                  addFab={addFab}
                  canEdit={canEdit}
                />
              </div>
            }
            noIndent={true}
          />
        </Card>
        {this.state.createEditDialogOpen && (
          <EmergencyContactsDialog
            initialDialogData={this.state.initialDialogData}
            open={this.state.createEditDialogOpen}
            handleSubmit={(dialogData) =>
              this.handleCreateEditDialogSubmit(dialogData)
            }
            handleCancel={() => this.toggleCreateEditDialog()}
            title={dialogTitle}
            icon={dialogIcon}
          />
        )}
        {confirmedOpen && (
          <ConfirmedDialog
            title={getString(stringsComponent, 'MY_DETAILS_TITLE')}
            open={confirmedOpen}
            close={this.handleConfirmed}
          />
        )}
        {this.state.confirmDialogOpen && (
          <ConfirmationDialog
            open={this.state.confirmDialogOpen}
            cancel={() => this.toggleConfirmDialog()}
            confirm={this.handleConfirmDialogSubmit}
            emergencyName={this.state.submitDialogData.name}
            emergencyPhone={this.state.submitDialogData.phone}
            dialogText={getString(stringsComponent, 'CONFIRM_HELP_TEXT')}
          />
        )}
        {this.state.deleteDialogOpen && (
          <DeleteDialog
            open={this.state.deleteDialogOpen}
            cancel={() => this.toggleDeleteDialog()}
            deleteContact={this.handleDeleteDialogSubmit}
            subject={
              <React.Fragment>
                <strong className={classes.bold}>
                  {this.state.contactToDelete.name}
                </strong>
              </React.Fragment>
            }
            dialogContent={getString(
              stringsComponent,
              'DELETE_CONTACT_MESSAGE'
            )}
            dialogContentNoSubject={getString(
              stringsComponent,
              'DELETE_CONTACT_MESSAGE_NO_NAME'
            )}
          />
        )}
      </div>
    );
  }
}

EmergencyContactsSection.propTypes = {
  classes: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  EmergencyContactsSection
);
